/**
 * Merges an updated asset document into assets.items and selectedAssetsAggregatedData.
 */
export default function mergeUpdatedAssetInAssetsState(state, updatedAsset) {
  if (!updatedAsset?._id || !state) return state;

  const assetId = String(updatedAsset._id);
  const items = state.items.map((asset) => (
    String(asset._id) === assetId ? { ...asset, ...updatedAsset } : asset
  ));

  const isSelected = state.selectedItems.some((id) => String(id) === assetId);
  if (!isSelected) {
    return { ...state, items };
  }

  const aggregated = state.selectedAssetsAggregatedData || {};
  const nextAggregated = { ...aggregated };

  if ('altText' in updatedAsset) nextAggregated.altText = updatedAsset.altText;
  if (updatedAsset.products) nextAggregated.products = updatedAsset.products;
  if (updatedAsset.productVariants) nextAggregated.productVariants = updatedAsset.productVariants;
  if (updatedAsset.channelAlt) nextAggregated.channelAlt = updatedAsset.channelAlt;

  return {
    ...state,
    items,
    selectedAssetsAggregatedData: nextAggregated,
  };
}
